import type { RouteRecordNameGeneric } from 'vue-router'

import { routeAutoRepeatCreate } from '@/routers/routes/mainRoutes/routeAccountings/autoRepeatsRoutes.ts'
import { routeDunningCreate } from '@/routers/routes/mainRoutes/routeAccountings/dunningRoutes.ts'
import { routePaymentEntryCreate } from '@/routers/routes/mainRoutes/routeAccountings/paymentEntriesRoutes.ts'
import { routePurchaseInvoiceCreate } from '@/routers/routes/mainRoutes/routeAccountings/puchaseInvoiceRoutes.ts'
import { routeSalesInvoiceCreate } from '@/routers/routes/mainRoutes/routeAccountings/salesInvoiceRoutes.ts'
import { routeTodoCreate } from '@/routers/routes/mainRoutes/routeActivities/todoRoutes.ts'
import { routePurchaseOrderCreate } from '@/routers/routes/mainRoutes/routeBuying/purchaseOrderRoutes'
import { routeRequestForQuotationCreate } from '@/routers/routes/mainRoutes/routeBuying/requestForQuotationRoutes'
import { routeSupplierQuotationCreate } from '@/routers/routes/mainRoutes/routeBuying/supplierQuotationRoutes'
import { routeEmployeeCreate } from '@/routers/routes/mainRoutes/routeHR/employeeRoutes.ts'
import { routeMarketingCampaignCreate } from '@/routers/routes/mainRoutes/routeMarketing/marketingCampaignRoutes'
import { routeDistributionListCreate } from '@/routers/routes/mainRoutes/routeMarketing/routeNewsletter/distributionListRoutes'
import { routeNewsletterArticleCreate } from '@/routers/routes/mainRoutes/routeMarketing/routeNewsletter/newsletterArticleRoutes'
import { routeDeliveryNoteCreate } from '@/routers/routes/mainRoutes/routeProjects/deliveryNoteRoutes.ts'
import { routeProjectCreate } from '@/routers/routes/mainRoutes/routeProjects/projectRoutes.ts'
import { routeTaskCreate } from '@/routers/routes/mainRoutes/routeProjects/taskRoutes.ts'
import { routeTimesheetCreate } from '@/routers/routes/mainRoutes/routeProjects/timesheetRoutes.ts'
import { routeDealCreate } from '@/routers/routes/mainRoutes/routeSales/dealsRoutes.ts'
import { routeQuotationCreate } from '@/routers/routes/mainRoutes/routeSales/quotationsRoutes.ts'
import { routeSalesOrderCreate } from '@/routers/routes/mainRoutes/routeSales/salesOrdersRoutes.ts'
import { routeNewActivityTypeCreate } from '@/routers/routes/mainRoutes/routeServices/activityTypesRoutes.ts'
import { routeItemGroupCreate } from '@/routers/routes/mainRoutes/routeServices/routeItems/itemGroupsRoutes.ts'
import { routeItemCreate } from '@/routers/routes/mainRoutes/routeServices/routeItems/itemsRoutes.ts'
import { routeSerialNoCreate } from '@/routers/routes/mainRoutes/routeServices/routeItems/serialNoRoutes'
import { routeItemPriceCreate } from '@/routers/routes/mainRoutes/routeServices/routePrices/itemPricesRoutes.ts'
import { routePriceListCreate } from '@/routers/routes/mainRoutes/routeServices/routePrices/priceListRoutes.ts'
import { routePricingRuleCreate } from '@/routers/routes/mainRoutes/routeServices/routePrices/pricingRuleRoutes.ts'
import { routeUOMCreate } from '@/routers/routes/mainRoutes/routeServices/uomRoutes.ts'
import { routeCurrencySettingsCreate } from '@/routers/routes/mainRoutes/routeSettings/currencyRoutes.ts'
import { routeDataImportCreate } from '@/routers/routes/mainRoutes/routeSettings/dataImportRoutes.ts'
import { routeLetterheadCreate } from '@/routers/routes/mainRoutes/routeSettings/letterheadRoutes.ts'
import { routePrintFormatCreate } from '@/routers/routes/mainRoutes/routeSettings/printFormatRoutes.ts'
import { routeAccountCreate } from '@/routers/routes/mainRoutes/routeSettings/routeAccounting/accountsRoutes.ts'
import { routeCostCenterCreate } from '@/routers/routes/mainRoutes/routeSettings/routeAccounting/costCenterRoutes.ts'
import { routeDunningPlanCreate } from '@/routers/routes/mainRoutes/routeSettings/routeAccounting/dunningPlanRoutes.ts'
import { routeDunningTypeCreate } from '@/routers/routes/mainRoutes/routeSettings/routeAccounting/dunningTypesRoutes.ts'
import { routeManagementReportRowCreate } from '@/routers/routes/mainRoutes/routeSettings/routeAccounting/managementReportRowRoutes.ts'
import { routeManagementReportSummaryRowCreate } from '@/routers/routes/mainRoutes/routeSettings/routeAccounting/managementReportSummaryRowRoutes.ts'
import { routePaymentTermCreate } from '@/routers/routes/mainRoutes/routeSettings/routeAccounting/paymentTermsRoutes.ts'
import { routePaymentTermsTemplateCreate } from '@/routers/routes/mainRoutes/routeSettings/routeAccounting/paymentTermsTemplatesRoutes.ts'
import { routeVatReturnRowCreate } from '@/routers/routes/mainRoutes/routeSettings/routeAccounting/vatReturnRowRoutes.ts'
import { routeNotificationCreate } from '@/routers/routes/mainRoutes/routeSettings/routeAutomation/notificationRoutes.ts'
import { routeSlackCreate } from '@/routers/routes/mainRoutes/routeSettings/routeAutomation/slackRoutes.ts'
import { routeCustomerGroupCreate } from '@/routers/routes/mainRoutes/routeSettings/routeBRM/customerGroupRoutes'
import { routeTWPhoneTypeCreate } from '@/routers/routes/mainRoutes/routeSettings/routeBRM/phoneTypeRoutes.ts'
import { routeTWRatingCreate } from '@/routers/routes/mainRoutes/routeSettings/routeBRM/ratingRoutes.ts'
import { routeRoleCreate } from '@/routers/routes/mainRoutes/routeSettings/routeBRM/roleRoutes.ts'
import { routeSalutationCreate } from '@/routers/routes/mainRoutes/routeSettings/routeBRM/salutationRoutes'
import { routeSupplierGroupCreate } from '@/routers/routes/mainRoutes/routeSettings/routeBRM/supplierGroupRoutes'
import { routeWeblinkTypeCreate } from '@/routers/routes/mainRoutes/routeSettings/routeBRM/weblinkTypeRoutes.ts'
import { routeConnectedAppCreate } from '@/routers/routes/mainRoutes/routeSettings/routeEmail/connectedAppRoutes.ts'
import { routeEmailAccountCreate } from '@/routers/routes/mainRoutes/routeSettings/routeEmail/emailAccountRoutes.ts'
import { routeEmailDomainCreate } from '@/routers/routes/mainRoutes/routeSettings/routeEmail/emailDomainRoutes.ts'
import { routeEmailTemplateCreate } from '@/routers/routes/mainRoutes/routeSettings/routeEmail/emailTemplateRoutes.ts'
import { routeWebhookCreate } from '@/routers/routes/mainRoutes/routeSettings/routeInterfaces/webhookRoutes.ts'
import { routeQuotationLostReasonCreate } from '@/routers/routes/mainRoutes/routeSettings/routeSales/quotationLostReasonRoutes.ts'
import { routeTagCreate } from '@/routers/routes/mainRoutes/routeSettings/tagsRoutes.ts'
import { routeTermsAndConditionsSettingsCreate } from '@/routers/routes/mainRoutes/routeSettings/termsAndConditionsSettingRoutes.ts'
import { routeUserCreate } from '@/routers/routes/mainRoutes/routeSettings/usersRoutes.ts'
import { routePurchaseReceiptCreate } from '@/routers/routes/mainRoutes/routeStock/purchaseReceiptsRoutes'
import { routeStockEntryCreate } from '@/routers/routes/mainRoutes/routeStock/stockEntriesRoutes'
import { routeWarehouseCreate } from '@/routers/routes/mainRoutes/routeStock/warehousesRoutes'

export const listCreateRouteMap: Record<string, RouteRecordNameGeneric> = {
  Account: routeAccountCreate.name,
  'Activity Type': routeNewActivityTypeCreate.name,
  'Auto Repeat': routeAutoRepeatCreate.name,
  'Connected App': routeConnectedAppCreate.name,
  'Cost Center': routeCostCenterCreate.name,
  Currency: routeCurrencySettingsCreate.name,
  'Customer Group': routeCustomerGroupCreate.name,
  'Data Import': routeDataImportCreate.name,
  'Delivery Note': routeDeliveryNoteCreate.name,
  Dunning: routeDunningCreate.name,
  'Dunning Plan': routeDunningPlanCreate.name,
  'Dunning Type': routeDunningTypeCreate.name,
  'Email Account': routeEmailAccountCreate.name,
  'Email Domain': routeEmailDomainCreate.name,
  'Email Group': routeDistributionListCreate.name,
  'Email Template': routeEmailTemplateCreate.name,
  Employee: routeEmployeeCreate.name,
  Item: routeItemCreate.name,
  'Item Group': routeItemGroupCreate.name,
  'Item Price': routeItemPriceCreate.name,
  'Letter Head': routeLetterheadCreate.name,
  'Marketing Campaign': routeMarketingCampaignCreate.name,
  Newsletter: routeNewsletterArticleCreate.name,
  Notification: routeNotificationCreate.name,
  Opportunity: routeDealCreate.name,
  'Payment Entry': routePaymentEntryCreate.name,
  'Payment Term': routePaymentTermCreate.name,
  'Payment Terms Template': routePaymentTermsTemplateCreate.name,
  'Price List': routePriceListCreate.name,
  'Pricing Rule': routePricingRuleCreate.name,
  'Print Format': routePrintFormatCreate.name,
  Project: routeProjectCreate.name,
  'Purchase Invoice': routePurchaseInvoiceCreate.name,
  'Purchase Order': routePurchaseOrderCreate.name,
  'Purchase Receipt': routePurchaseReceiptCreate.name,
  Quotation: routeQuotationCreate.name,
  'Quotation Lost Reason': routeQuotationLostReasonCreate.name,
  'Request for Quotation': routeRequestForQuotationCreate.name,
  'Sales Invoice': routeSalesInvoiceCreate.name,
  'Sales Order': routeSalesOrderCreate.name,
  Salutation: routeSalutationCreate.name,
  'Serial No': routeSerialNoCreate.name,
  'Slack Webhook URL': routeSlackCreate.name,
  'Stock Entry': routeStockEntryCreate.name,
  'Supplier Group': routeSupplierGroupCreate.name,
  'Supplier Quotation': routeSupplierQuotationCreate.name,
  Tag: routeTagCreate.name,
  Task: routeTaskCreate.name,
  'Terms and Conditions': routeTermsAndConditionsSettingsCreate.name,
  Timesheet: routeTimesheetCreate.name,
  ToDo: routeTodoCreate.name,
  'TW Management Report Row': routeManagementReportRowCreate.name,
  'TW Management Report Summary Row': routeManagementReportSummaryRowCreate.name,
  'TW Phone Type': routeTWPhoneTypeCreate.name,
  'TW Rating': routeTWRatingCreate.name,
  'TW Role': routeRoleCreate.name,
  'TW VAT Return Row': routeVatReturnRowCreate.name,
  'TW Weblink Type': routeWeblinkTypeCreate.name,
  UOM: routeUOMCreate.name,
  User: routeUserCreate.name,
  Warehouse: routeWarehouseCreate.name,
  Webhook: routeWebhookCreate.name,
}
